import React from 'react';
import { format, parseISO } from 'date-fns';
import s from './BookingDetails.module.scss';
import Page from 'modules/app/components/Page';
import ProfileMenuHeader from 'modules/app/components/ProfileMenu/ProfileMenuHeader';
import { ReactComponent as PenIcon } from 'images/new-icons/pen.svg';
import Button from 'components/shared/Button';
import useGetServiceById from 'sdk/hooks/booking/useGetServiceById';
import { useNavigate } from 'react-router-dom';

type Props = {
  booking: any;
  onClose: () => void;
};

const BookingDetails: React.FC<Props> = ({ booking, onClose }) => {
  const navigate = useNavigate();
  const { data: serviceData } = useGetServiceById(booking?.service);

  return (
    <div className={s.container}>
      <Page activeLink="/profile">
        <ProfileMenuHeader text={serviceData?.name || 'Booking Details'} onClose={onClose} />

        <div className={s.content}>
          <div className={s.datetime_wrapper}>
            <div className={s.datetime_row}>
              <div className={s.datetime_label}>Date and time</div>
              <div className={s.datetime_value}>
                <div className={s.datetime_text}>
                  {booking?.date ? format(parseISO(booking.date), 'dd MMM yyyy') : ''},
                  <br />
                  <span className={s.accent_text}>
                    {booking?.start_time
                      ? format(parseISO(`2000-01-01T${booking.start_time}`), 'h:mm a')
                      : ''}{' '}
                    -
                    {booking?.end_time
                      ? format(parseISO(`2000-01-01T${booking.end_time}`), 'h:mm a')
                      : ''}
                  </span>
                </div>
                <div className={s.datetime_icon}>
                  <PenIcon />
                </div>
              </div>
            </div>
          </div>

          <div className={s.details_container}>
            <div className={s.client_name_wrapper}>
              <img
                src={booking?.teams?.avatar}
                className={s.client_avatar}
                alt="Service provider avatar"
              />
              <div className={s.client_name}>{booking?.teams?.full_name}</div>
            </div>
            <div className={s.service_name}>{serviceData?.name}</div>

            <div className={s.appointment_details}>
              <div className={s.details_group}>
                <div className={s.details_label}>Services</div>
                <div className={s.details_value}>{serviceData?.name}</div>
              </div>
              <div className={s.details_group}>
                <div className={s.details_label}>Professional</div>
                <div className={s.details_value}>{booking?.teams?.full_name}</div>
              </div>
              <div className={s.details_group}>
                <div className={s.details_label}>Phone number</div>
                <div className={s.details_value}>{booking?.teams?.phone_number}</div>
              </div>
              <div className={s.details_group}>
                <div className={s.details_label}>Email</div>
                <div className={s.details_value}>{booking?.teams?.email}</div>
              </div>
              <div className={s.details_group}>
                <div className={s.details_label}>Location</div>
                <div className={s.details_value}>1588 Maple Grove Avenue Willowbrook, OR 97225</div>
              </div>
            </div>
          </div>

          <div className={s.buttons_container}>
            <Button ligtGrey wide className={s.buttons_item} onClick={() => navigate('/feed')}>
              Cancel
            </Button>
          </div>
        </div>
      </Page>
    </div>
  );
};

export default BookingDetails;

